import React from 'react';
import { useForm } from 'react-hook-form';
import { DataScience } from '../../utils/formNames';
import { getFormData } from '../../utils/sessionStorage';
import { FORM_HOST } from '../../utils/constants';
import EnrollmentForm from './EnrollmentForm';
import EnrollmentFormCheckboxListInput from '../FormInputs/FormCheckboxListInput';
import EnrollmentFormError from '../FormInputs/FormError';

const formName = DataScience;
const pardotFormUrl = `${FORM_HOST}/l/772833/2020-04-14/5c6zn8`;
const callbackLocations = {
  success_location: `${FORM_HOST}/l/772833/2020-07-06/7k97rl/772833/58639/data_science_success.js`,
  error_location: `${FORM_HOST}/l/772833/2020-07-06/7k97rj/772833/58637/data_science_error.js`,
};

const DataScienceForm = () => {
  const { register, handleSubmit, formState, errors } = useForm({
    mode: 'onBlur',
    submitFocusError: false,
  });

  const previousData = getFormData(formName);

  return (
    <EnrollmentForm
      formName={formName}
      callbackLocations={callbackLocations}
      actionUrl={pardotFormUrl}
      formValid={formState.isValid}
      validationHandler={handleSubmit}
    >
      <legend>Data Science</legend>
      <p>Which of the following roles are you interested in?</p>
      <EnrollmentFormCheckboxListInput
        name="data_roles"
        id="data-analyst-role"
        label="Data Analyst"
        value="Data Analyst"
        defaultValue={previousData.data_roles}
        inputRef={register}
      />
      <EnrollmentFormCheckboxListInput
        name="data_roles"
        id="data-scientist-role"
        label="Data Scientist"
        value="Data Scientist"
        defaultValue={previousData.data_roles}
        inputRef={register}
      />
      <EnrollmentFormCheckboxListInput
        name="data_roles"
        id="machine-learning-role"
        label="Machine Learning Engineer"
        value="Machine Learning Engineer"
        defaultValue={previousData.data_roles}
        inputRef={register}
      />
      <EnrollmentFormCheckboxListInput
        name="data_roles"
        id="data-engineer-role"
        label="Data Engineer"
        value="Data Engineer"
        defaultValue={previousData.data_roles}
        inputRef={register}
      />
      <EnrollmentFormError errorField={errors.data_roles} blockError />
    </EnrollmentForm>
  );
};

export default DataScienceForm;
